import type { ReactNode } from 'react';

export const symbol_input: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-139q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v139h680v-520H140v141q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q80-586.25 80-599v-141q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm379-289H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-509 110-509h409l-82-82q-9-9-8.58-21.1.41-12.1 9.58-20.9 9-9 21.5-9t21.5 9l133 133q9 9 9 21t-9 21L480-324q-9 9-21 8.5t-21.39-9.5q-8.61-9-8.61-21.5t9-21.5l81-81Z"
		/>
	</svg>
);
